
import { useNavigate } from "react-router-dom";
import "./exam.scss"; // Import SCSS

interface Props {
    type: string;
    data?: any
}

const SessionCompleted: React.FC<Props> = ({ type = "completed", data }) => {
  const navigate = useNavigate();
    const getMsg = () => {
        if (type = "no-session") {
            return " The session you are trying to access is not available. Please check the session details or contact your trainer.";
        } else if (type = "completed") {
            return "You have already completed this session. No further attempts are allowed.";
        } else if (type = "expired") {
            return "The session has expired as the allowed time slot is over. Please contact your trainer if re-examination is required.";
        }
    }

    return (
        <div className={"has-text-centered box p-5"}>
            <h1 className="is-size-1 mb-5"> {getMsg()}</h1>
            <button
                className="button is-danger"
                onClick={()=>navigate("/")}
              >
                <i className="fas fa-play-circle"></i> Close 
              </button>
        </div>
    );
};

export default SessionCompleted;